(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-catalogue]').textContent);
    const catalogue = [...new Map(config.products.map(p => [p.id, p])).values()];
    const personalisedProducts = config.personalised || [];
    const urlParams = new URLSearchParams(window.location.search);
    let wallId = (urlParams.get('gallery_wall') || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0,80);
    try { wallId = wallId || sessionStorage.getItem('skylit_gallery_wall_current') || ''; } catch(e) {}
    if(!wallId) wallId='gwb_'+Math.random().toString(36).slice(2,10)+Date.now().toString(36);
    try { sessionStorage.setItem('skylit_gallery_wall_current',wallId); } catch(e) {}
    const storageKey='skylit_gallery_wall_v1_'+wallId;
    // Gallery wall journey log (admin /api/gallery-wall/event), shared with the planner chat.
    function wallEvent(event,props,orderId,planId){
      if(!config.planner)return;
      try{fetch(config.planner+'event',{method:'POST',keepalive:true,headers:{'Content-Type':'text/plain'},body:JSON.stringify({wall_id:wallId,event,order_id:orderId||null,plan_id:planId||null,props:{...(props||{}),at:Date.now()}})}).catch(()=>{});}catch(e){}
    }
    try{if(!sessionStorage.getItem('skylit_gwe_viewed_'+wallId)){sessionStorage.setItem('skylit_gwe_viewed_'+wallId,'1');wallEvent('wall_viewed');}}catch(e){}
    const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:config.currency}).format(n/100);
    const shortTitle = p => p.title.split('|')[0].trim();
    const eligible = v => v.available && !/digital|canvas/i.test(v.title) && !(config.country !== 'GB' && /frame/i.test(v.option1) && !/unframed/i.test(v.option1) && /70|80/.test(v.option2));
    const products = catalogue.filter(p => typeof p.image === 'string' && p.image && p.variants.some(eligible));
    const templates = [
      {id:'pair', name:'The perfect pair', sizes:['40x50','40x50'], layout:'row'},
      {id:'a4', name:'A small moment', sizes:['A4','A4'], layout:'row'},
      {id:'statement', name:'The statement pair', sizes:['60x80','60x80'], layout:'row'},
      {id:'trio', name:'Three in harmony', sizes:['30x40','30x40','30x40'], layout:'row'},
      {id:'hero', name:'One bright centre', sizes:['50x70','A4','A4'], layout:'hero'},
      {id:'grid', name:'A constellation of four', sizes:['30x40','30x40','30x40','30x40'], layout:'grid', columns:2},
      {id:'five', name:'Five little wonders', sizes:['30x40','A4','30x40','A4','30x40'], layout:'staggered', columns:3},
      {id:'six', name:'Six in balance', sizes:Array(6).fill('30x40'), layout:'grid', columns:3},
      {id:'nine', name:'A universe of nine', sizes:Array(9).fill('A4'), layout:'grid', columns:3}
    ];
    let template = templates[0];
    const maxPrints = 30;
    let movePrints = false, printDrag = null;
    const selected = [null,null];
    const thumbnailStates = new Map();
    const normalSize = value => String(value || '').replace(/cm|\s/gi,'').toUpperCase();
    const sizeLabel = value => /A4/i.test(value) ? 'A4' : String(value).replace(/cm/gi,'').trim().replace(/\s*[x×]\s*/i,' × ') + ' cm';
    let wallBounds = {width:500,height:300};
    let active = 0, busy = false, sourceMode='space', restoring=true;
    const atcMorph=window.SkylitAtcMorph||{start:()=>false,success(){},reset(){},active:()=>false,settle:()=>Promise.resolve()};
    let cartItems=[],frameControls=null,cartRequest=0;
    const $ = s => root.querySelector(s);
    // Programmatic focus (a panel's heading, the button that opened a panel
    // when it closes, a dragged print) makes Safari draw its keyboard focus
    // ring even after a tap, so things looked stuck "selected". Rings stay for
    // keyboard users: a tap puts the builder in pointer mode, Tab/Enter/Escape/
    // arrows take it out (CSS: .gwb--pointer).
    document.addEventListener('pointerdown',()=>root.classList.add('gwb--pointer'),true);
    document.addEventListener('keydown',e=>{
      if(e.metaKey||e.ctrlKey||e.altKey)return;
      const typing=e.target instanceof Element&&e.target.matches('input,textarea,select,[contenteditable]');
      if(e.key==='Tab'||e.key==='Escape'||(!typing&&(e.key==='Enter'||e.key===' '||e.key.startsWith('Arrow'))))root.classList.remove('gwb--pointer');
    },true);
    let slots = [], removeButtons = [];
    const viewport = $('.gwb-viewport'), scene = $('.gwb-scene');
    let scale = 1, fitScale = 1, x = 0, y = 0, settleTimer = 0;
    const legibleScale = 1;
    let customPhoto=null, customPhotoActive=false;
    const points = new Map();
    let gesture = null, moved = false, exploreEnabled = false;
    const clamp = (n,a,b) => Math.max(a,Math.min(b,n));
    const isPersonalised = s => Boolean(s && s.kind==='personalised');
    const personalisedLabel = handle => ({
      'starmap':'Star Map',
      'personalised-moon-map-by-skylit-studio':'Moon Map',
      'personalised-moon-phase-for-family-by-skylit-studio':'Family Moon',
      'custom-location-map-by-skylit-studio':'Location Map',
      'custom-print':'Custom Photo Print',
      'your-name-from-orbit':'Your Name From Orbit'
    })[handle] || '';
    const selectionTitle = s => isPersonalised(s) ? s.title : shortTitle(s.product);
    const selectionImage = s => isPersonalised(s) ? s.image : s.product.image;
    // Planned = designed by "Describe your wall" and saved as a draft, not yet in the basket.
    const isPlanned = s => isPersonalised(s) && Boolean(s.planned);
    const plannedPrice = s => Number(personalisedProducts.find(p=>p.handle===s.handle)?.prices?.[s.variantId] ?? (config.currency==='GBP'?s.price:0) ?? 0);
    const selectionPrice = s => isPlanned(s) ? plannedPrice(s) : isPersonalised(s) ? Number(s.price || 0)+Number(s.cartFrame?.final_price||s.cartFrame?.price||0) : s.variant.price;
    const selectionSize = (s,index=0) => isPersonalised(s) ? (s.size || template.sizes[index]) : (s ? s.variant.option2 || s.variant.title : template.sizes[index]);
    function saveWall(){
      if(restoring)return;
      try{
        sessionStorage.setItem(storageKey,JSON.stringify({template:template.id,custom:template.id==='custom'?template:null,active,sourceMode,slots:selected.map(s=>{
          if(!s)return null;
          if(isPersonalised(s))return s;
          return {kind:'catalogue',productId:s.product.id,variantId:s.variant.id};
        })}));
      }catch(e){}
    }
    function restoreWall(){
      let saved=null;try{saved=JSON.parse(sessionStorage.getItem(storageKey)||'null');}catch(e){}
      if(!saved)return;
      template=templates.find(t=>t.id===saved.template)||template;
      if(saved.template==='custom' && saved.custom && Array.isArray(saved.custom.sizes) && saved.custom.sizes.length){
        const c=saved.custom;
        const sizes=c.sizes.slice(0,maxPrints).map(size=>typeof size==='string' && /^(A4|\d+(?:\.\d+)?\s*[x×]\s*\d+(?:\.\d+)?(?:\s*cm)?)$/i.test(size)?size:'30x40');
        template={id:'custom',name:'Your own gallery',sizes,layout:['row','grid','staggered','hero'].includes(c.layout)?c.layout:'grid',columns:clamp(Math.round(Number(c.columns))||3,1,6),gap:clamp(Number(c.gap)||32,5.5,165)};
        if(template.layout==='hero' && sizes.length!==3)template.layout='grid';
        if(Array.isArray(c.positions) && c.positions.length===sizes.length && c.positions.every(p=>Array.isArray(p)&&p.length===2&&p.every(v=>Number.isFinite(v)&&Math.abs(v)<=10000)))template.positions=c.positions;
      }
      selected.length=template.sizes.length;selected.fill(null);
      (saved.slots||[]).slice(0,selected.length).forEach((s,i)=>{
        if(!s)return;
        if(s.kind==='personalised'){selected[i]=s;return;}
        const product=catalogue.find(p=>String(p.id)===String(s.productId));
        const variant=product&&product.variants.find(v=>String(v.id)===String(s.variantId));
        if(product&&variant)selected[i]={product,variant};
      });
      active=clamp(Number(saved.active)||0,0,selected.length-1);
      sourceMode=saved.sourceMode==='space'?'space':'personalised';
    }
    function transform() {
      x = clamp(x, -1000*scale + viewport.clientWidth*.2, viewport.clientWidth*.8);
      y = clamp(y, -700*scale + viewport.clientHeight*.2, viewport.clientHeight*.8);
      scene.style.transform = `translate(${x}px,${y}px) scale(${scale})`;
      removeButtons.forEach(b=>{b.style.transform=`scale(${1/scale}) translate(-100%,calc(-100% - 8px))`;});
      // Chromium keeps a composited layer's raster at the scale it had when the
      // transform started changing, so a small print zoomed in fullscreen stayed
      // soft in Edge even though the 1200px file had arrived. Promote during the
      // gesture, then drop will-change once it settles so the layer re-rasters
      // (and re-decodes the images) at the final scale.
      scene.style.willChange='transform';clearTimeout(settleTimer);
      settleTimer=setTimeout(()=>{scene.style.willChange='';},180);
      $('[data-zoom-label]').textContent = `${Math.round(scale/fitScale*100)}%`;
    }
    // The highest sofa cushions begin at 67.5% of the Sage image height.
    // Reserve the wall above 62%, leaving visible clearance over the furniture.
    const sageWallBottom = .62;
    function isSageRoom(){return !customPhotoActive && $('.gwb-room-image').src.includes('gallery-room-sage-wide');}
    function aboveFurniture(position,index){
      if(!isSageRoom())return position;
      const room=$('.gwb-room-image');
      const bottom=parseFloat(room.style.top)+parseFloat(room.style.height)*sageWallBottom;
      return [position[0],Math.min(position[1],bottom-270-dimensions(selected[index],index)[1])];
    }
    function frameSageRoom(room){
      if(!isSageRoom())return;
      // Keep the gallery's normal fit. Reframe the photograph so the sofa sits
      // below the prints, cropping more of the furniture on narrow screens.
      const width=viewport.clientWidth,height=viewport.clientHeight;
      const aspect=room.naturalWidth/room.naturalHeight||2016/780;
      const wallBottom=Math.max(height*.80,y+(270+wallBounds.height/2)*scale+18);
      const photoHeight=Math.max(width/aspect,wallBottom/sageWallBottom,(height-wallBottom)/(1-sageWallBottom));
      room.style.width=photoHeight*aspect/scale+'px';room.style.height=photoHeight/scale+'px';
      room.style.left=(width/2-x-photoHeight*aspect/2)/scale+'px';
      room.style.top=(wallBottom-photoHeight*sageWallBottom-y)/scale+'px';
    }
    function fit() {
      const room=$('.gwb-room-image');
      updateRoomButton();
      if(!customPhotoActive && window.matchMedia('(min-width:750px)').matches){
        // Keep room and prints in one coordinate system. Resizing or entering
        // fullscreen must change their shared scale, not their relative sizes.
        const roomHeight=1100,roomWidth=roomHeight*(room.naturalWidth/room.naturalHeight || 3);
        // Fill the preview with a gentle shared zoom; keep every print in view.
        const roomScale=Math.max(viewport.clientWidth/roomWidth,viewport.clientHeight/roomHeight)*1.08;
        // Room-fill alone left a 30x40 print about 110px wide on a laptop, where
        // star-map hairlines alias into noise. Aim for scene scale 1, but never
        // past the scale at which the wall top and the furniture (room bottom,
        // scene y 820) still both fit the stage: the room must keep reading as
        // a room, so the stage height (70vh on desktop) is the real lever.
        const topMargin=Math.min(72,viewport.clientHeight*.14);
        const roomFits=(viewport.clientHeight-topMargin)/(550+wallBounds.height/2);
        fitScale=Math.min(Math.max(roomScale,Math.min(legibleScale,roomFits)),
          (viewport.clientWidth-36)/(wallBounds.width+20),(viewport.clientHeight-Math.min(72,viewport.clientHeight*.14)-18)/(wallBounds.height+30),1.15);
        scale=fitScale;x=viewport.clientWidth/2-500*scale;
        // Anchor the furniture at the bottom rather than cropping it with the ceiling.
        y=clamp(viewport.clientHeight-(270+roomHeight/2)*scale,
          Math.min(72,viewport.clientHeight*.14)-(270-wallBounds.height/2)*scale,viewport.clientHeight-18-(270+wallBounds.height/2)*scale);
        room.style.width=roomWidth+'px';room.style.height=roomHeight+'px';
        room.style.left=(500-roomWidth/2)+'px';room.style.top=(270-roomHeight/2)+'px';
        transform();frameSageRoom(room);extendRoom(room);return;
      }
      fitScale = Math.min((viewport.clientWidth-36)/(wallBounds.width+20), (viewport.clientHeight-160)/(wallBounds.height+30), 1.15);
      scale=fitScale; x=viewport.clientWidth/2-500*scale; y=viewport.clientHeight/2-270*scale; transform();
      if(customPhotoActive){positionPhoto();extendRoom(room);return;}
      // Size the photo box to the photo's own shape (not the viewport's), at
      // the scale that just covers the stage, so zooming out or panning
      // reveals the rest of the room instead of the edge of a crop.
      const aspect=room.naturalWidth/room.naturalHeight||3;
      let roomH=viewport.clientHeight/scale,roomW=roomH*aspect;
      if(roomW<viewport.clientWidth/scale){roomW=viewport.clientWidth/scale;roomH=roomW/aspect;}
      room.style.width=roomW+'px';room.style.height=roomH+'px';
      room.style.left=(viewport.clientWidth/2-x)/scale-roomW/2+'px';room.style.top=(viewport.clientHeight/2-y)/scale-roomH/2+'px';
      frameSageRoom(room);extendRoom(room);
    }
    // The room photographs end at the ceiling and just below the furniture.
    // Continue them past both edges so a zoomed-out wall still sits in a room:
    // the top rows stretched upward (plain wall), and a floor band below in
    // the photo's own bottom colour.
    let roomExt=null;const roomEdgeCache={};
    function roomEdges(room){
      const key=room.currentSrc||room.src;
      if(roomEdgeCache[key])return roomEdgeCache[key];
      if(!room.complete||!room.naturalWidth){room.addEventListener('load',refitKeepingView,{once:true});return null;}
      try{
        const w=room.naturalWidth,h=room.naturalHeight,c=document.createElement('canvas');c.width=w;c.height=1;
        const g=c.getContext('2d');g.drawImage(room,0,0,w,1,0,0,w,1);const top=c.toDataURL();
        g.clearRect(0,0,w,1);g.drawImage(room,0,h-4,w,4,0,0,w,1);
        const px=g.getImageData(0,0,w,1).data;let r=0,gr=0,b=0;
        for(let i=0;i<px.length;i+=4){r+=px[i];gr+=px[i+1];b+=px[i+2];}
        const n=px.length/4,floor=[r/n,gr/n,b/n].map(Math.round);
        return roomEdgeCache[key]={top,floor:`rgb(${floor})`,floorDark:`rgb(${floor.map(v=>Math.round(v*.86))})`};
      }catch(e){return roomEdgeCache[key]={};}
    }
    function extendRoom(room){
      if(!roomExt){roomExt=[0,1].map(()=>{const d=document.createElement('div');d.className='gwb-room-ext';d.setAttribute('aria-hidden','true');return d;});room.before(...roomExt);}
      const edges=!customPhotoActive&&!room.hidden&&roomEdges(room);
      roomExt.forEach(d=>d.hidden=!edges||!edges.top);
      if(!edges||!edges.top)return;
      const l=parseFloat(room.style.left),t=parseFloat(room.style.top),w=parseFloat(room.style.width),h=parseFloat(room.style.height);
      const reach=Math.max(1500,4*viewport.clientHeight/scale);
      Object.assign(roomExt[0].style,{left:l+'px',width:w+'px',top:t-reach+1+'px',height:reach+'px',background:`url(${edges.top}) 0 0/100% 100% no-repeat`});
      Object.assign(roomExt[1].style,{left:l+'px',width:w+'px',top:t+h-1+'px',height:reach+'px',background:`linear-gradient(${edges.floor},${edges.floorDark} 40%)`});
    }
    // Refit for a new room photo, but keep the shopper's zoom and the point
    // they were looking at: changing the room should not reset the view.
    function refitKeepingView(){
      const zoomRatio=scale/fitScale,cx=(viewport.clientWidth/2-x)/scale,cy=(viewport.clientHeight/2-y)/scale;
      fit();
      if(Math.abs(zoomRatio-1)>.005){scale=fitScale*zoomRatio;x=viewport.clientWidth/2-cx*scale;y=viewport.clientHeight/2-cy*scale;transform();}
    }
    function zoom(next,cx=viewport.clientWidth/2,cy=viewport.clientHeight/2) {
      next=clamp(next,fitScale*.7,fitScale*3);
      x=cx-(cx-x)*next/scale; y=cy-(cy-y)*next/scale; scale=next; transform();
    }
    // Basket items carry _selected_type (PRINT / FRAMED / CANVAS); catalogue
    // prints carry the variant title. Canvas is stretched, not framed.
    const isCanvasFinish = title => /canvas/i.test(title);
    const unframedFinish = title => isCanvasFinish(title) || /unframed/i.test(title) || (/\bprint\b/i.test(title) && !/fram/i.test(title));
    function dimensions(s,index=0) {
      const label = selectionSize(s,index);
      const match = label.match(/(\d+)\s*x\s*(\d+)/i);
      let [w,h] = match ? [Number(match[1]),Number(match[2])] : /A4/i.test(label) ? [21,29.7] : [30,40];
      if(isPersonalised(s)){
        // Family Moon stores composition, including on older basket/saved-wall items.
        const orientation=s.handle==='your-name-from-orbit' ? 'landscape' : s.handle==='personalised-moon-phase-for-family-by-skylit-studio'
          ? (s.properties?._composition==='quad-portrait'?'portrait':'landscape') : s.orientation;
        if(orientation==='landscape' && w<h || orientation==='portrait' && w>h) [w,h]=[h,w];
      }else if(s?.product?.landscape) [w,h]=[h,w];
      const finishTitle=isPersonalised(s)?`${s.cartFrame?'Framed':s.type||''} ${s.cartFrame?.variant_options?.[0]||s.frame||''}`:(s?.variant?.title||'');
      const border = s && unframedFinish(finishTitle) ? 0 : 18;
      return [w*5.5+border,h*5.5+border];
    }
    function chooseVariant(product,index,previous) {
      const variants=product.variants.filter(v=>eligible(v)&&normalSize(v.option2)===normalSize(template.sizes[index]));
      return variants.find(v=>previous && v.option1===previous.option1 && v.option3===previous.option3)
        || variants.find(v=>/black/i.test(v.option1)) || variants[0];
    }
    const frameClearance=10, collisionEpsilon=1e-7;
    function overlaps(a,ad,b,bd){
      return a[0]<b[0]+bd[0]+frameClearance-collisionEpsilon && a[0]+ad[0]+frameClearance>b[0]+collisionEpsilon && a[1]<b[1]+bd[1]+frameClearance-collisionEpsilon && a[1]+ad[1]+frameClearance>b[1]+collisionEpsilon;
    }
    function separatePositions(positions,dims){
      // Recover old overlapping walls and make room when artwork changes size.
      const placed=[];
      positions.forEach((position,i)=>{
        let next=position.slice();
        if(placed.some((p,j)=>overlaps(next,dims[i],p,dims[j]))){
          const candidates=[];
          placed.forEach((p,j)=>{
            candidates.push([p[0]-dims[i][0]-frameClearance,next[1]],[p[0]+dims[j][0]+frameClearance,next[1]],
              [next[0],p[1]-dims[i][1]-frameClearance],[next[0],p[1]+dims[j][1]+frameClearance]);
          });
          candidates.push([Math.max(...placed.map((p,j)=>p[0]+dims[j][0]))+frameClearance,next[1]]);
          next=candidates.filter(c=>!placed.some((p,j)=>overlaps(c,dims[i],p,dims[j])))
            .sort((a,b)=>Math.hypot(a[0]-position[0],a[1]-position[1])-Math.hypot(b[0]-position[0],b[1]-position[1]))[0];
        }
        placed.push(next);
      });
      return placed;
    }
    function moveWithoutOverlap(start,target,index,positions,dims){
      const next=start.slice(),[w,h]=dims[index];
      // Sweep each axis, so even a fast pointer jump cannot pass through a frame.
      let dx=target[0]-start[0];
      positions.forEach((p,i)=>{if(i===index)return;const [ow,oh]=dims[i];
        if(start[1]>=p[1]+oh+frameClearance-collisionEpsilon || start[1]+h+frameClearance<=p[1]+collisionEpsilon)return;
        if(dx>0 && start[0]+w+frameClearance<=p[0]+collisionEpsilon)dx=Math.min(dx,p[0]-w-frameClearance-start[0]);
        if(dx<0 && start[0]>=p[0]+ow+frameClearance-collisionEpsilon)dx=Math.max(dx,p[0]+ow+frameClearance-start[0]);
      });
      next[0]+=dx;let dy=target[1]-start[1];
      positions.forEach((p,i)=>{if(i===index)return;const [ow,oh]=dims[i];
        if(next[0]>=p[0]+ow+frameClearance-collisionEpsilon || next[0]+w+frameClearance<=p[0]+collisionEpsilon)return;
        if(dy>0 && start[1]+h+frameClearance<=p[1]+collisionEpsilon)dy=Math.min(dy,p[1]-h-frameClearance-start[1]);
        if(dy<0 && start[1]>=p[1]+oh+frameClearance-collisionEpsilon)dy=Math.max(dy,p[1]+oh+frameClearance-start[1]);
      });
      next[1]+=dy;return next;
    }
    function movePrint(target,index){
      return moveWithoutOverlap(template.positions[index],aboveFurniture(target,index),index,template.positions,selected.map((s,i)=>dimensions(s,i)));
    }
    function layoutWall() {
      const dims=selected.map((s,i)=>dimensions(s,i)), gap=template.gap||32;
      let positions=[];
      if(template.positions?.length===dims.length){
        positions=separatePositions(template.positions,dims);
        template.positions=positions;
      }else{
        if(template.layout==='row') {
          let left=0; const height=Math.max(...dims.map(d=>d[1]));
          dims.forEach(([w,h])=>{positions.push([left,(height-h)/2]);left+=w+gap;});
        }else if(template.layout==='hero' && dims.length===3){
          const stackHeight=dims[1][1]+gap+dims[2][1], height=Math.max(dims[0][1],stackHeight);
          positions.push([0,(height-dims[0][1])/2],[dims[0][0]+gap,(height-stackHeight)/2],[dims[0][0]+gap,(height-stackHeight)/2+dims[1][1]+gap]);
        }else{
          const columns=Math.min(template.columns||Math.ceil(Math.sqrt(dims.length)),dims.length);
          const widths=Array(columns).fill(0),heights=Array(Math.ceil(dims.length/columns)).fill(0);
          dims.forEach(([w,h],i)=>{widths[i%columns]=Math.max(widths[i%columns],w);heights[Math.floor(i/columns)]=Math.max(heights[Math.floor(i/columns)],h);});
          dims.forEach(([w,h],i)=>{
            const col=i%columns,row=Math.floor(i/columns);
            const left=widths.slice(0,col).reduce((sum,v)=>sum+v+gap,0);
            const top=heights.slice(0,row).reduce((sum,v)=>sum+v+gap,0);
            positions.push([left+(widths[col]-w)/2+(template.layout==='staggered' && row%2?(widths[0]+gap)/2:0),top+(heights[row]-h)/2]);
          });
        }
        const width=Math.max(...dims.map((d,i)=>positions[i][0]+d[0])),height=Math.max(...dims.map((d,i)=>positions[i][1]+d[1]));
        positions=positions.map(([left,top])=>[left-width/2,top-height/2]);
      }
      // Keep the wall origin stable while moving a frame; Fit includes all edges.
      wallBounds={width:2*Math.max(...dims.map((d,i)=>Math.max(Math.abs(positions[i][0]),Math.abs(positions[i][0]+d[0])))),height:2*Math.max(...dims.map((d,i)=>Math.max(Math.abs(positions[i][1]),Math.abs(positions[i][1]+d[1]))))};
      slots.forEach((slot,i)=>{slot.style.left=positions[i][0]+'px';slot.style.top=positions[i][1]+'px';});
      removeButtons.forEach((b,i)=>{b.style.left=positions[i][0]+dims[i][0]+'px';b.style.top=positions[i][1]+'px';});
    }
    function makeCustom(){
      if(template.id==='custom')return;
      template={...template,id:'custom',name:'Your own gallery',sizes:selected.map((s,i)=>selectionSize(s,i)),gap:template.gap||32};
    }
    function refreshLayout(){$('[data-layout-status]').textContent='';buildSlots();render();fit();}
    function setMovePrints(enabled){
      movePrints=enabled;printDrag=null;
      if(enabled){makeCustom();setExplore(false);}
      viewport.classList.toggle('gwb-viewport--moving',enabled);
      $('[data-explore-hint]').textContent=enabled?'Drag a frame to move it · Scroll outside prints':exploreEnabled?'Drag to explore · Pinch to zoom':'View locked · Scroll normally';
      $('[data-move-prints]').setAttribute('aria-pressed',String(enabled));
      $('[data-move-hint]').parentElement.hidden=!enabled;
      $('[data-move-hint]').textContent=enabled?'Drag a print to position it. Use arrow keys on a focused print for small adjustments.':'Choose an arrangement, or turn on Move prints to position each one yourself.';
    }
    function buildSlots() {
      const wall=$('.gwb-pair'), tabs=$('.gwb-tabs');wall.replaceChildren();tabs.replaceChildren();removeButtons=[];
      slots=template.sizes.map((size,i)=>{
        const slot=document.createElement('button');slot.className='gwb-print';slot.dataset.slot=i;
        const image=document.createElement('img');image.alt='';image.draggable=false;
        image.addEventListener('error',()=>{
          const current=selected[i];
          if(!isPersonalised(current) || !current.renderBacked)return;
          current.imagePending=true;delete current.displayImage;thumbnailStates.delete(current.image);render();
        });
        const badge=document.createElement('span');slot.append(image,badge);wall.append(slot);
        // Sibling, not child: a button cannot nest inside the slot button.
        const closeBtn=document.createElement('button');closeBtn.type='button';closeBtn.className='gwb-print-remove';
        closeBtn.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        closeBtn.addEventListener('pointerdown',e=>e.stopPropagation());
        closeBtn.addEventListener('click',e=>{e.stopPropagation();removePrint(i);});
        closeBtn.style.transform=`scale(${1/scale}) translate(-100%,calc(-100% - 8px))`;
        wall.append(closeBtn);removeButtons.push(closeBtn);
        const tab=document.createElement('button');tab.dataset.edit=i;tab.textContent=`${String(i+1).padStart(2,'0')} · Print ${i+1}`;const state=document.createElement('small');state.dataset.slotState='';tab.append(state);tabs.append(tab);
        const edit=()=>{active=i;render();};tab.addEventListener('click',edit);
        slot.addEventListener('click',e=>{
          if(e.detail && moved)return;
          if(movePrints){edit();return;}
          edit();
          // Leave room for the storefront's sticky header on mobile.
          const header=document.querySelector('sticky-header');
          const offset=(header?.getBoundingClientRect().height || 0)+16;
          const picker=$('.gwb-picker');
          const top=picker.getBoundingClientRect().top;
          if(top<offset || top+Math.min(picker.offsetHeight,320)>window.innerHeight){
            window.scrollTo({top:Math.max(0,window.scrollY+top-offset),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
          }
        });
        return slot;
      });
    }
    function ensurePersonalisedThumbnail(selection){
      const url=selection.image;
      if(!url || !selection.renderBacked)return;
      const existing=thumbnailStates.get(url);
      if(existing?.status==='ready'){
        selection.imagePending=false;selection.displayImage=existing.src;queueMicrotask(()=>{render();});return;
      }
      if(existing?.status==='loading')return;
      const state={status:'loading',attempts:0,src:'',started:Date.now()};thumbnailStates.set(url,state);
      const check=()=>{
        if(state.status!=='loading')return;
        state.attempts++;
        const probe=new Image();
        probe.onload=()=>{
          state.status='ready';state.src=url+(url.includes('?')?'&':'?')+'gwb='+Date.now();
          selected.forEach(item=>{if(isPersonalised(item)&&item.image===url){item.imagePending=false;item.displayImage=state.src;}});
          render();
        };
        probe.onerror=()=>{
          // ~20s without a preview: say so, rather than leave the spinner looking stuck.
          if(!state.slow&&Date.now()-state.started>20000){state.slow=true;render();}
          // A planned design's render can be cut short when several start at once;
          // ask for that one slot again after ~30s and ~60s (no-op once it exists).
          if(selection.planned&&(state.attempts===15||state.attempts===30)&&config.planner){
            fetch(config.planner+'render',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({plan_id:selection.planId,wall_id:wallId,index:selection.planIndex})}).catch(()=>{});
          }
          if(state.attempts<40)setTimeout(check,2000);
          else state.status='waiting';
        };
        probe.src=url+(url.includes('?')?'&':'?')+'gwb_probe='+Date.now();
      };
      check();
    }
    function applyTemplate(next) {
      setMovePrints(false);
      const old=selected.slice(); template=next;
      selected.length=next.sizes.length;
      let reset=0,finishChanged=0;
      next.sizes.forEach((_,i)=>{
        const previous=old[i];
        if(isPersonalised(previous)){selected[i]=previous;return;}
        const variant=previous && chooseVariant(previous.product,i,previous.variant);
        selected[i]=variant ? {product:previous.product,variant} : null;
        if(previous && !variant)reset++;
        if(variant && variant.option1!==previous.variant.option1)finishChanged++;
      });
      active=Math.min(active,selected.length-1);buildSlots();render();fit();
      $('[data-status]').textContent=reset ? 'Some prints are unavailable in these sizes. Choose a replacement for the empty spaces.' : finishChanged ? 'Frame finishes updated to available options for these sizes. You can change them below.' : '';
    }
    const templateList=$('[data-templates]');
    templates.filter(t=>!['a4','statement'].includes(t.id)).forEach(t=>{
      const button=document.createElement('button');button.type='button';button.dataset.template=t.id;
      const diagram=document.createElement('span');diagram.className=`gwb-layout-icon gwb-layout-icon--${t.layout}`;diagram.setAttribute('aria-hidden','true');
      if(t.columns)diagram.style.gridTemplateColumns=`repeat(${t.columns}, 10px)`;
      t.sizes.forEach(()=>diagram.append(document.createElement('i')));
      const name=document.createElement('strong');name.textContent=t.id==='pair'?'Pair':t.name;
      const description=document.createElement('span');description.textContent=t.id==='pair'?'2 prints · Choose your sizes':t.layout==='hero'?'50 × 70 cm + 2 A4':t.id==='five'?'3 × 30 × 40 cm + 2 A4':`${t.sizes.length} × ${sizeLabel(t.sizes[0])}`;
      button.append(diagram,name,description);button.addEventListener('click',()=>applyTemplate(t));templateList.append(button);
    });
    const customButton=document.createElement('button');customButton.type='button';customButton.dataset.template='custom';
    customButton.innerHTML='<span class="gwb-layout-icon gwb-layout-icon--custom" aria-hidden="true">＋</span><strong>Create your own</strong><span>Add prints · Arrange your way</span>';
    templateList.prepend(customButton);
    customButton.addEventListener('click',()=>{makeCustom();render();});
    // One toolbar; controls stay attached to their existing behaviour when moved.
    const toolbar=document.createElement('div');toolbar.className='gwb-toolbar';toolbar.setAttribute('role','group');toolbar.setAttribute('aria-label','Gallery wall controls');
    toolbar.innerHTML='<button type="button" data-open-layout aria-haspopup="dialog"><svg class="gwb-tool-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3" y="4" width="8" height="10" rx="1"/><rect x="13" y="4" width="8" height="6" rx="1"/><rect x="13" y="12" width="8" height="8" rx="1"/><rect x="3" y="16" width="8" height="4" rx="1"/></svg><span class="gwb-tool-label">Layout</span> <strong data-layout-label>Pair</strong><span class="gwb-tool-chevron" aria-hidden="true">⌄</span></button><button type="button" data-open-add aria-haspopup="dialog"><svg class="gwb-tool-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg><span>Add<span class="gwb-tool-extra"> print</span></span></button><button type="button" data-open-arrange aria-haspopup="dialog"><svg class="gwb-tool-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1"/><circle cx="15" cy="6" r="2"/><circle cx="9" cy="12" r="2"/><circle cx="17" cy="18" r="2"/></svg><span class="gwb-tool-label">Arrange</span><span class="gwb-tool-chevron" aria-hidden="true">⌄</span></button><button type="button" data-open-room aria-haspopup="dialog"><img data-room-thumbnail alt=""><span class="gwb-tool-label" data-room-label>Warm oak</span><span class="gwb-tool-chevron" aria-hidden="true">⌄</span></button>';
    // Float the controls over the top of the preview, as the other customizers do.
    // A sibling of the viewport, not a child, so pressing a button never starts a pan.
    $('.gwb-viewport').before(toolbar);
    const panels={};
    function makePanel(key,title,trigger){
      const dialog=document.createElement('dialog');dialog.className='gwb-tool-panel';dialog.dataset.panel=key;dialog.setAttribute('aria-label',title);
      const heading=document.createElement('div');heading.className='gwb-panel-heading';
      const h=document.createElement('h2');h.textContent=title;h.tabIndex=-1;
      const close=document.createElement('button');close.type='button';close.textContent='×';close.setAttribute('aria-label','Close '+title);close.addEventListener('click',()=>dialog.close());heading.append(h,close);dialog.append(heading);root.append(dialog);
      let previousPanelOverflow='';
      function positionPanel(){
        if(!dialog.open)return;
        if(window.matchMedia('(max-width:749px)').matches){
          const vv=window.visualViewport,width=vv?.width||window.innerWidth,height=vv?.height||window.innerHeight;
          const left=vv?.offsetLeft||0,top=vv?.offsetTop||0;
          dialog.style.width=Math.min(430,width-24)+'px';
          dialog.style.maxHeight=`calc(${height}px - 32px - env(safe-area-inset-top) - env(safe-area-inset-bottom))`;
          dialog.style.left=left+(width-dialog.getBoundingClientRect().width)/2+'px';
          dialog.style.top=top+(height-dialog.getBoundingClientRect().height)/2+'px';
        }else{
          dialog.style.removeProperty('width');
          const rect=trigger.getBoundingClientRect();dialog.style.left=Math.max(16,Math.min(rect.left,window.innerWidth-576))+'px';dialog.style.top=Math.max(16,Math.min(rect.bottom+10,window.innerHeight-400))+'px';
          dialog.style.maxHeight=Math.max(160,window.innerHeight-parseFloat(dialog.style.top)-16)+'px';
        }
      }
      new ResizeObserver(positionPanel).observe(dialog);
      trigger.addEventListener('click',()=>{
        previousPanelOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';
        trigger.setAttribute('aria-expanded','true');dialog.showModal();positionPanel();h.focus({preventScroll:true});
        window.addEventListener('resize',positionPanel);window.visualViewport?.addEventListener('resize',positionPanel);window.visualViewport?.addEventListener('scroll',positionPanel);
      });
      dialog.addEventListener('close',()=>{
        document.documentElement.style.overflow=previousPanelOverflow;
        window.removeEventListener('resize',positionPanel);window.visualViewport?.removeEventListener('resize',positionPanel);window.visualViewport?.removeEventListener('scroll',positionPanel);
        trigger.setAttribute('aria-expanded','false');trigger.focus({preventScroll:true});
      });
      dialog.addEventListener('click',e=>{if(e.target!==dialog)return;const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();});
      panels[key]=dialog;return dialog;
    }
    const layoutPanel=makePanel('layout','Choose a layout',$('[data-open-layout]'));layoutPanel.append(templateList);
    templateList.addEventListener('click',e=>{if(e.target.closest('[data-template]'))layoutPanel.close();});
    const addPanel=makePanel('add','Add a print',$('[data-open-add]'));
    const newSize=$('[data-new-size]').parentElement;newSize.firstChild.textContent='Print size';addPanel.append(newSize,$('[data-add-print]'));
    const arrangePanel=makePanel('arrange','Arrange your wall',$('[data-open-arrange]'));
    const arrangeFields=document.createElement('div');arrangeFields.className='gwb-layout-fields';
    for(const selector of ['[data-arrangement]','[data-columns]','[data-spacing]'])arrangeFields.append($(selector).parentElement);
    const mode=$('[data-layout-mode]');arrangePanel.append(arrangeFields,mode,$('[data-tidy-layout]'));$('[data-tidy-layout]').textContent='Auto-arrange';
    const order=document.createElement('section');order.className='gwb-print-order';
    order.innerHTML='<h3>Print order</h3><p>Move prints between slots. Each print keeps its design, size and frame.</p><ol data-print-order></ol><p data-order-status role="status" aria-live="polite"></p>';
    arrangePanel.append(order);
    function renderPrintOrder(){
      const list=order.querySelector('[data-print-order]');
      const focused=document.activeElement;
      const focusIndex=focused?.dataset.orderIndex,focusDirection=focused?.dataset.orderDirection;
      list.replaceChildren();
      selected.forEach((selection,index)=>{
        const row=document.createElement('li');
        const image=document.createElement('img');image.alt='';
        if(selection)image.src=selectionImage(selection);else image.hidden=true;
        const label=document.createElement('span');label.textContent=`${String(index+1).padStart(2,'0')} · ${selection?selectionTitle(selection):'Empty slot'} · ${sizeLabel(selectionSize(selection,index))}`;
        row.append(image,label);
        for(const direction of [-1,1]){
          const button=document.createElement('button');button.type='button';button.textContent=direction<0?'↑':'↓';
          button.dataset.orderIndex=index;button.dataset.orderDirection=direction;
          button.setAttribute('aria-label',`Move print ${index+1} ${direction<0?'earlier':'later'}`);
          button.disabled=index+direction<0||index+direction>=selected.length;
          button.addEventListener('click',()=>{
            const target=index+direction;makeCustom();
            [selected[index],selected[target]]=[selected[target],selected[index]];
            [template.sizes[index],template.sizes[target]]=[template.sizes[target],template.sizes[index]];
            if(active===index)active=target;else if(active===target)active=index;
            refreshLayout();
            order.querySelector('[data-order-status]').textContent=`Print ${index+1} moved to slot ${target+1}.`;
            const next=order.querySelector(`[data-order-index="${target}"][data-order-direction="${direction}"]`);
            (next.disabled?order.querySelector(`[data-order-index="${target}"][data-order-direction="${-direction}"]`):next).focus({preventScroll:true});
          });
          row.append(button);
        }
        list.append(row);
      });
      if(focusIndex!==undefined)order.querySelector(`[data-order-index="${focusIndex}"][data-order-direction="${focusDirection}"]`)?.focus({preventScroll:true});
    }
    const roomPanel=makePanel('room','Picture it in your room',$('[data-open-room]'));roomPanel.append($('.gwb-rooms'),$('[data-upload-tools]'),$('[data-upload-status]'),$('[data-photo-file]'));
    root.querySelectorAll('[data-room]').forEach(button=>button.addEventListener('click',e=>{if(e.isTrusted)roomPanel.close();}));
    const move=$('[data-move-prints]');move.innerHTML='<svg class="gwb-tool-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3v18M3 12h18M9 6l3-3 3 3M9 18l3 3 3-3M6 9l-3 3 3 3M18 9l3 3-3 3"/></svg><span class="gwb-tool-label">Move prints</span>';$('[data-open-room]').before(move);
    const help=document.createElement('p');help.className='gwb-toolbar-help';help.append($('[data-move-hint]'));$('.gwb-heading').after(help);
    help.after($('[data-layout-status]'));
    const remove=$('[data-remove-print]');remove.className='gwb-remove-print';$('.gwb-selection').append(remove);
    $('[data-custom-layout]').remove();
    function updateRoomButton(){
      const room=$('.gwb-room-image');const button=[...root.querySelectorAll('[data-room]')].find(b=>b.dataset.room===room.getAttribute('src')||new URL(b.dataset.room,location.href).href===room.src);
      $('[data-room-thumbnail]').src=customPhotoActive&&customPhoto?customPhoto.url:room.src;
      $('[data-room-label]').textContent=customPhotoActive?'Your room':button?.textContent.trim()||'Room';
    }
    $('[data-add-print]').addEventListener('click',()=>{
      if(selected.length>=maxPrints)return;
      makeCustom();
      template.sizes.push($('[data-new-size]').value);selected.push(null);active=selected.length-1;
      if(template.positions){
        const right=Math.max(...template.positions.map((p,i)=>p[0]+dimensions(selected[i],i)[0]));
        template.positions.push([right+(template.gap||32),-dimensions(null,active)[1]/2]);
      }
      if(template.layout==='hero')template.layout='grid';
      refreshLayout();panels.add.close();
    });
    function removePrint(index){
      // Last print: clear it back to an empty slot rather than leave no wall.
      if(selected.length<=1){if(selected[0]){selected[0]=null;render();renderCartImport();}return;}
      makeCustom();selected.splice(index,1);template.sizes.splice(index,1);template.positions?.splice(index,1);
      if(template.layout==='hero')template.layout='grid';
      if(active>index||active>=selected.length)active=Math.max(0,active-1);refreshLayout();renderCartImport();
      $('[data-layout-status]').textContent='Print removed from this wall. Your basket is unchanged.';
    }
    $('[data-remove-print]').addEventListener('click',()=>removePrint(active));
    function arrange(){makeCustom();delete template.positions;template.layout=$('[data-arrangement]').value;template.columns=Number($('[data-columns]').value);template.gap=Number($('[data-spacing]').value)*5.5;refreshLayout();}
    $('[data-arrangement]').addEventListener('change',arrange);
    $('[data-columns]').addEventListener('change',arrange);
    $('[data-spacing]').addEventListener('change',arrange);
    $('[data-tidy-layout]').addEventListener('click',()=>{arrange();panels.arrange.close();});
    $('[data-move-prints]').addEventListener('click',()=>{setMovePrints(!movePrints);render();});
    function scrollActiveTab(){
      const activeTab=root.querySelector(`[data-edit="${active}"]`),tabList=$('.gwb-tabs');
      if(!activeTab)return;
      const tab=activeTab.getBoundingClientRect(),list=tabList.getBoundingClientRect();
      if(tab.left<list.left)tabList.scrollLeft+=tab.left-list.left;
      else if(tab.right>list.right)tabList.scrollLeft+=tab.right-list.right;
    }
    function render() {
      renderPrintOrder();
      $('[data-layout-label]').textContent=template.id==='custom'?'Custom':['pair','a4','statement'].includes(template.id)?'Pair':template.name;
      $('[data-open-add]').disabled=selected.length>=maxPrints;
      $('[data-move-hint]').parentElement.hidden=!movePrints;
      $('[data-add-print]').disabled=selected.length>=maxPrints;
      $('[data-remove-print]').disabled=selected.length<=1;
      $('[data-remove-print]').textContent=`Remove print ${active+1}`;
      $('[data-arrangement]').value=['row','grid','staggered'].includes(template.layout)?template.layout:'grid';
      $('[data-columns]').value=String(template.columns||3);
      $('[data-columns]').disabled=template.layout==='row';
      $('[data-columns]').parentElement.hidden=template.layout==='row';
      $('[data-spacing]').value=String(Math.round((template.gap||32)/5.5));
      $('[data-layout-mode]').textContent=template.positions?'Individually positioned · Tidy layout will arrange all prints again.':'';
      root.querySelectorAll('[data-template]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.template===template.id)));
      $('.gwb-template').textContent=template.name;
      const previewPrints=selected.filter(s=>s&&(!isPersonalised(s)||isPlanned(s)));
      const inBasket=selected.filter(s=>isPersonalised(s)&&s.cartKey).length;
      if(!atcMorph.active())$('.gwb-add').textContent=previewPrints.length?`Add ${previewPrints.length} new ${previewPrints.length===1?'print':'prints'} to basket`:'View basket';
      const basketCopy=inBasket?`${inBasket} ${inBasket===1?'print already':'prints already'} in your basket.`:'';
      $('[data-basket-summary]').textContent=basketCopy||(previewPrints.length?`${previewPrints.length} ${previewPrints.length===1?'print ready':'prints ready'} to add to your basket.`:'Find a print you love and try it on your wall.');
      root.querySelectorAll('[data-edit]').forEach(b=>{
        const index=Number(b.dataset.edit),item=selected[index];b.setAttribute('aria-pressed',String(index===active));
        b.querySelector('[data-slot-state]').textContent=!item?'Choose a print':isPlanned(item)?'Planned for you':isPersonalised(item)?(item.cartKey?'Already in basket':'Not in basket'):'Preview only';
      });
      scrollActiveTab();
      slots.forEach((b,i)=>{
        const s=selected[i]; b.classList.toggle('gwb-print--empty',!s); b.setAttribute('aria-pressed',String(i===active));
        const img=b.querySelector('img');
        const generating=isPersonalised(s)&&s.renderBacked&&s.imagePending!==false;
        b.classList.toggle('gwb-print--generating',Boolean(generating));
        b.classList.toggle('gwb-print--slow',Boolean(generating&&thumbnailStates.get(s.image)?.slow));
        if(s&&generating){img.removeAttribute('src');img.alt='';b.setAttribute('aria-label',`Edit print ${i+1}: ${selectionTitle(s)}. Generating preview.`);ensurePersonalisedThumbnail(s);}
        else if(s){img.src=isPersonalised(s)?(s.displayImage||selectionImage(s)):selectionImage(s); img.alt=selectionTitle(s); b.setAttribute('aria-label',`Edit print ${i+1}: ${selectionTitle(s)}`);}
        else {img.removeAttribute('src'); img.alt='';b.setAttribute('aria-label',`Choose print ${i+1}, ${sizeLabel(template.sizes[i])}`);}
        b.querySelector('span').textContent=String(i+1).padStart(2,'0');
        const [w,h]=dimensions(s,i); b.style.width=w+'px'; b.style.height=h+'px';
        const title=isPersonalised(s)?`${s.cartFrame?'Framed':s.type||''} ${s.cartFrame?.variant_options?.[0]||s.frame||''}`:(s?.variant?.title || 'Black');
        b.style.borderColor=/white/i.test(title)?'#f5f3ec':/dark brown/i.test(title)?'#513a2b':/natural|brown/i.test(title)?'#ba9061':'#292a28';
        const unframed=unframedFinish(title);
        b.classList.toggle('gwb-print--framed-art',Boolean(s) && !unframed);
        b.classList.toggle('gwb-print--canvas',Boolean(s) && isCanvasFinish(title));
        const finish=/white/i.test(title)?'white':/dark brown/i.test(title)?'darkBrown':/natural|brown/i.test(title)?'natural':'black';
        const slice=finish==='black'?100:finish==='white'?115:110;
        // Same nine-slice assets and slice values as simple-product.js.
        b.style.borderImage=unframed?'none':`url("${config.frames[finish]}") ${slice} / 1 / 0 stretch`;
        b.style.borderWidth=unframed?'0px':'9px';
        const closeBtn=removeButtons[i];
        if(closeBtn){closeBtn.hidden=selected.length<=1&&!s;closeBtn.setAttribute('aria-label',`Remove print ${i+1}${s?`: ${selectionTitle(s)}`:''} from wall`);closeBtn.title='Remove from wall';closeBtn.classList.toggle('is-active',i===active);}
      });
      layoutWall();
      const s=selected[active]; $('[data-selected-title]').textContent=s?selectionTitle(s):`Choose print ${active+1} · ${sizeLabel(template.sizes[active])}`;
      $('[data-selection-state]').textContent=!s?'':isPlanned(s)?`Planned for you${s.reason?' · '+s.reason:''} · Not in your basket yet.`:isPersonalised(s)?(s.cartKey?'Already in your basket · Previewing it here adds no extra copy.':'This saved design is no longer in your basket.'):'Preview only · This print has not been added to your basket.';
      const options=$('.gwb-options'); options.replaceChildren();
      if(!s){
        const label=document.createElement('label');label.textContent='Size';
        const select=$('[data-new-size]').cloneNode(true);select.removeAttribute('data-new-size');select.setAttribute('aria-label','Size');select.value=template.sizes[active];
        select.addEventListener('change',()=>{makeCustom();template.sizes[active]=select.value;render();});label.append(select);options.append(label);
      }
      if(s && !isPersonalised(s)) s.product.options.forEach((name,index)=>{
        const label=document.createElement('label'); label.textContent=name==='Variant'?'Finish':name;
        const select=document.createElement('select'); select.setAttribute('aria-label',name==='Variant'?'Finish':name);
        const key=`option${index+1}`;
        const variants=s.product.variants.filter(eligible);
        const values=[...new Set(variants.filter(v=>index===0 || v.option1===s.variant.option1).map(v=>v[key]))];
        values.forEach(value=>{const o=document.createElement('option');o.value=value;o.textContent=value;o.selected=value===s.variant[key];select.append(o);});
        select.addEventListener('change',()=>{
          const matching=variants.filter(v=>v[key]===select.value && (index===0 || v.option1===s.variant.option1));
          s.variant=matching.find(v=>s.product.options.every((_,j)=>j===index || v[`option${j+1}`]===s.variant[`option${j+1}`])) || matching[0];
          if(template.id==='custom')template.sizes[active]=selectionSize(s,active);
          render();
        }); label.append(select); options.append(label);
      });
      if(isPersonalised(s)) renderPersonalisedActions(options,s);
      $('[data-total]').parentElement.hidden=!previewPrints.length;
      $('[data-total]').textContent=money(previewPrints.reduce((sum,s)=>sum+selectionPrice(s),0));
      $('.gwb-add').disabled=busy || !selected.every(Boolean);
      renderProducts();
      renderSourceMode();saveWall();
    }
    function renderProducts() {
      const list=$('.gwb-products'), query=$('[data-search]').value.trim().toLowerCase(); list.replaceChildren();
      products.filter(p=>p.title.toLowerCase().includes(query)).forEach(p=>{
        const b=document.createElement('button'); b.className='gwb-product';b.setAttribute('aria-pressed',String(selected[active]?.product?.id===p.id));
        const img=document.createElement('img');img.src=p.image;img.alt='';img.loading='lazy';
        const title=document.createElement('span');title.textContent=shortTitle(p);b.append(img,title);
        const available=chooseVariant(p,active,selected[active]?.variant);
        b.disabled=!available;
        if(!available){const note=document.createElement('small');note.textContent=`Unavailable in ${sizeLabel(template.sizes[active])}`;b.append(note);}
        b.addEventListener('click',()=>{
          const variant=chooseVariant(p,active,selected[active]?.variant);
          if(!variant)return;
          selected[active]={product:p,variant};$('[data-status]').textContent='';render();
        });list.append(b);
      });
      if(!list.children.length){const p=document.createElement('p');p.textContent=products.length?'No prints match your search. Try “Moon” or “Nebula”.':'Space prints are not available here yet. Please check back shortly.';list.append(p);}
    }

    function isoDate(raw){
      if(!raw)return '';
      const s=String(raw).split(' - ')[0].replace(/,/g,' ').replace(/(\d+)(st|nd|rd|th)\b/i,'$1');
      const t=Date.parse(s);if(isNaN(t))return /^\d{4}-\d{2}-\d{2}$/.test(raw)?raw:'';
      const d=new Date(t);return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    }
    function sourceMoment(){
      const source=selected.find(isPersonalised);if(!source)return null;
      const p=source.properties||{};
      const date=isoDate(p['Date & time']||p.Date||p['Moon 1 Date']);
      const lat=p._loc_lat||p._moon1_lat||'',lng=p._loc_lng||p._moon1_lng||'';
      const place=p.Location||p['Moon 1 Location']||'';
      return date||lat?{date,lat,lng,place,source:source.handle}:null;
    }
    function customiserUrl(product,index=active){
      const url=new URL(product.url,window.location.origin);
      url.searchParams.set('gallery_wall',wallId);url.searchParams.set('gallery_slot',String(index));
      url.searchParams.set('size',template.sizes[index]);
      const moment=sourceMoment();
      if(moment){
        if(moment.date)url.searchParams.set('prefill_date',moment.date);
        if(isFinite(parseFloat(moment.lat))&&isFinite(parseFloat(moment.lng))){
          url.searchParams.set('prefill_lat',moment.lat);url.searchParams.set('prefill_lng',moment.lng);
          if(moment.place)url.searchParams.set('prefill_place',String(moment.place).slice(0,80));
        }
      }
      return url.pathname+url.search;
    }
    async function openCustomiser(product,index=active){saveWall();if(customPhoto)$('[data-status]').textContent='Keeping your room photo on this device…';await writeRoom();window.location.assign(customiserUrl(product,index));}
    function renderPersonalisedProducts(){
      const list=$('[data-personalised-products]');list.replaceChildren();const moment=sourceMoment();
      personalisedProducts.forEach(product=>{
        const b=document.createElement('button');b.type='button';b.className='gwb-personalised-card';
        const img=document.createElement('img');img.src=product.image;img.alt='';img.loading='lazy';
        const title=document.createElement('strong');title.textContent=personalisedLabel(product.handle)||product.title;
        const hint=document.createElement('small');
        const cross=(moment&&((moment.source==='starmap'&&product.handle.includes('moon-map'))||(moment.source.includes('moon-map')&&product.handle==='starmap')));
        hint.textContent=cross?'Use the same night and place':moment&&product.handle==='custom-location-map-by-skylit-studio'?'Use the same place':moment&&product.handle.includes('moon-phase')?'Start Moon 1 with this moment':'Create for this slot';
        b.append(img,title,hint);b.addEventListener('click',()=>openCustomiser(product));list.append(b);
      });
    }
    function renderSourceMode(){
      root.querySelectorAll('[data-source]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.source===sourceMode)));
      const personal=sourceMode==='personalised';$('[data-personalised-products]').hidden=!personal;
      $('.gwb-search').hidden=personal;$('.gwb-products').hidden=personal;
      if(personal)renderPersonalisedProducts();
    }
    root.querySelectorAll('[data-source]').forEach(b=>b.addEventListener('click',()=>{sourceMode=b.dataset.source;render();}));

    function pairedFrame(item){
      const p=item.properties||{},frames=cartItems.filter(i=>i.handle==='skylit-studio-frame');
      if(p._cart_line_ref){const exact=frames.find(f=>f.properties?._paired_with_line_ref===p._cart_line_ref);if(exact)return exact;}
      const keyed=frames.find(f=>!f.properties?._paired_with_line_ref&&f.properties?._paired_with_key===item.key);if(keyed)return keyed;
      const oid=p._OrderID||p.OrderID;
      const owners=cartItems.filter(i=>i.handle!=='skylit-studio-frame'&&(i.properties?._OrderID||i.properties?.OrderID)===oid);
      return oid&&owners.length===1?frames.find(f=>!f.properties?._paired_with_line_ref&&f.properties?._frame_for_order_id===oid):null;
    }
    function personalisedFromItem(item){
      const p=item.properties||{}, handle=item.handle||'';
      const frame=p._selected_frame||'';const type=p._selected_type||item.variant_options?.[0]||'';
      const fallback=item.image||(item.featured_image&&item.featured_image.url)||'';
      const renderImage=p._thumbnail_print||p._thumbnail_final||'';
      const meta=personalisedProducts.find(product=>product.handle===handle);
      return {kind:'personalised',handle,title:personalisedLabel(handle)||meta?.title||(item.product_title||'Personalised print').split('|')[0].trim(),productUrl:meta?.url||item.url||('/products/'+handle),variantId:item.variant_id,
        cartFrame:pairedFrame(item)||null,cartKey:item.key,lineRef:p._cart_line_ref||item.key,orderId:p._OrderID||p.OrderID,image:renderImage||fallback,renderBacked:Boolean(renderImage),imagePending:Boolean(renderImage),
        size:p._selected_size||item.variant_options?.[1]||template.sizes[active],type,frame,orientation:String(p.Orientation||p._orientation||'').toLowerCase(),
        price:Number(item.final_price||item.price||0),properties:p};
    }
    function represented(item){return selected.some(s=>isPersonalised(s)&&(s.cartKey===item.key||s.lineRef===(item.properties||{})._cart_line_ref));}
    const basketStrip=$('[data-cart-import-items]');
    let basketDrag=null,basketDragged=false;
    // Drag-to-scroll is for mice only. Touch and pen use the browser's own
    // horizontal scroll (momentum, snap, tap vs swipe): driving touch from
    // here left the strip stuck on iPhone.
    basketStrip.addEventListener('pointerdown',e=>{
      if(!e.isPrimary||e.button!==0||e.pointerType!=='mouse')return;
      basketDragged=false;
      basketDrag={id:e.pointerId,x:e.clientX,y:e.clientY,left:basketStrip.scrollLeft,dragging:false};
    });
    basketStrip.addEventListener('pointermove',e=>{
      if(!basketDrag||basketDrag.id!==e.pointerId)return;
      const dx=e.clientX-basketDrag.x,dy=e.clientY-basketDrag.y;
      if(!basketDrag.dragging){
        if(Math.max(Math.abs(dx),Math.abs(dy))<8)return;
        if(Math.abs(dy)>Math.abs(dx)){basketDrag=null;return;}
        basketDrag.dragging=true;basketDragged=true;
        basketStrip.classList.add('gwb-basket-dragging');
        basketStrip.setPointerCapture(e.pointerId);
      }
      e.preventDefault();basketStrip.scrollLeft=basketDrag.left-dx;
    });
    function finishBasketDrag(e){
      if(!basketDrag||basketDrag.id!==e.pointerId)return;
      basketDrag=null;basketStrip.classList.remove('gwb-basket-dragging');
      if(basketStrip.hasPointerCapture(e.pointerId))basketStrip.releasePointerCapture(e.pointerId);
    }
    window.addEventListener('pointerup',finishBasketDrag);
    window.addEventListener('pointercancel',finishBasketDrag);
    basketStrip.addEventListener('lostpointercapture',e=>{
      // Touch starts with implicit capture on the card; transferring it to
      // the strip must not end the gesture when the card releases capture.
      if(e.target===basketStrip)finishBasketDrag(e);
    });
    basketStrip.addEventListener('dragstart',e=>e.preventDefault());
    basketStrip.addEventListener('click',e=>{
      if(basketDragged&&e.detail!==0){e.preventDefault();e.stopImmediatePropagation();basketDragged=false;}
    },true);
    function renderCartImport(){
      // Rebuilt on cart changes and picks: keep the strip where the customer left it.
      const wrap=$('[data-cart-import]'),items=$('[data-cart-import-items]'),keepLeft=items.scrollLeft;items.replaceChildren();
      const candidates=cartItems.filter(i=>(i.properties||{})._OrderID||(i.properties||{}).OrderID).filter(i=>!/enhancement|upscale/i.test(i.product_title||'')).filter(i=>!represented(i));
      wrap.hidden=!candidates.length;if(!candidates.length)return;
      $('[data-cart-import-copy]').textContent=`${candidates.length} available to preview`;
      candidates.forEach(item=>{
        const selection=personalisedFromItem(item),b=document.createElement('button');b.type='button';b.className='gwb-basket-card';
        b.setAttribute('aria-label',`Preview ${selection.title} on wall`);
        const img=document.createElement('img');img.alt='';img.loading='lazy';
        const fallback=item.image||item.featured_image?.url||'';img.src=selection.image||fallback;
        img.addEventListener('error',()=>{if(fallback&&img.getAttribute('src')!==fallback)img.src=fallback;else img.style.visibility='hidden';});
        const copy=document.createElement('span');copy.className='gwb-basket-card-copy';
        const title=document.createElement('strong');title.textContent=selection.title;
        const detail=document.createElement('small');
        const size=String(selection.size||'').replace(/^(\d+)\s*[x×]\s*(\d+)(?:\s*cm)?$/i,'$1 × $2 cm');
        detail.textContent=[size,selection.cartFrame?.variant_options?.[0]||[selection.type,selection.frame].filter(Boolean).join(' · ')].filter(Boolean).join(' · ');
        const action=document.createElement('span');action.className='gwb-basket-card-action';action.textContent='Preview on wall';
        copy.append(title,detail,action);b.append(img,copy);
        b.addEventListener('click',()=>{selected[active]=personalisedFromItem(item);render();renderCartImport();});items.append(b);
      });
      items.scrollLeft=keepLeft;
    }
    async function loadCart(){
      try{
        const request=++cartRequest;
        const cart=await fetch(config.root+'cart.js',{credentials:'same-origin'}).then(r=>{if(!r.ok)throw new Error();return r.json();});
        if(request!==cartRequest)return;cartItems=cart.items||[];
        selected.forEach((s,i)=>{if(!isPersonalised(s))return;
          const ref=s.properties?._cart_line_ref;
          const candidates=cartItems.filter(item=>item.handle===s.handle&&(item.properties?._OrderID||item.properties?.OrderID)===s.orderId);
          // A planned design only becomes a basket item once its own order id is in the cart
          // (finished in the editor, or added with the wall); its planned line ref never is.
          const current=isPlanned(s)?(candidates.length===1?candidates[0]:null):ref?candidates.find(item=>item.properties?._cart_line_ref===ref):candidates.find(item=>item.key===s.cartKey)||(candidates.length===1?candidates[0]:null);
          if(current){const fresh=personalisedFromItem(current);if(fresh.image===s.image){fresh.imagePending=s.imagePending;fresh.displayImage=s.displayImage;}selected[i]=fresh;}
          else if(!isPlanned(s)){s.cartFrame=null;s.cartKey='';}
        });
        frameControls=null;render();
        const controls=await fetch(config.root+'?section_id=gallery-wall-frames',{credentials:'same-origin'}).then(r=>r.ok?r.text():'').catch(()=>'');
        if(request!==cartRequest)return;
        frameControls=new DOMParser().parseFromString(controls,'text/html');
        const returnedSlot=clamp(Number(urlParams.get('gallery_slot'))||0,0,selected.length-1);
        const exact=cartItems.find(i=>String((i.properties||{})._gallery_wall_id||'')===wallId&&String((i.properties||{})._gallery_wall_slot||'')===String(returnedSlot));
        if(exact&&urlParams.has('returned')){wallEvent('returned_to_wall',{slot:returnedSlot},(exact.properties||{})._OrderID||'');selected[returnedSlot]=personalisedFromItem(exact);active=returnedSlot;history.replaceState({},'',window.location.pathname);urlParams.delete('returned');render();$('[data-status]').textContent='Your personalised print is back in its gallery wall slot.';}
        renderCartImport();render();
      }catch(e){if(urlParams.get('returned'))$('[data-status]').textContent='Your design is in the basket, but we could not place it on the wall automatically. Refresh to try again.';}
    }
    // ── Size and frame colour for a print already in the basket ──────────────
    // Shopify can't change a line's variant, so a change adds the same design as
    // the new variant (same _OrderID and _cart_line_ref, so gift add-ons stay
    // paired) and then removes the old line; the add goes first so a failure
    // never loses the print. Size-priced gift wrap / bundle lines move to the
    // new size tier, and the saved design is told its new size and frame so
    // its basket mockup re-renders.
    const DATA_ROUTE={'starmap':'star-map-data','personalised-moon-map-by-skylit-studio':'moon-map-data','personalised-moon-phase-for-family-by-skylit-studio':'h-moon-map-data','custom-location-map-by-skylit-studio':'location-map-data','your-name-from-orbit':'name-landsat-data','custom-print':'custom-print-data'};
    const sizeToken=v=>String(v||'').replace(/\s*cm$/i,'').replace(/\s*[x×]\s*/i,'x').trim();
    const noFrame=v=>!v||/no frame|none/i.test(v);
    // Same shipping rule as space prints: large framed prints are UK only.
    const shippable=v=>!(config.country!=='GB'&&!noFrame(v.option3)&&/70|80/.test(v.option2||''));
    function basketChoices(s){
      const variants=personalisedProducts.find(p=>p.handle===s.handle)?.variants||[];
      const current=variants.find(v=>String(v.id)===String(s.variantId));
      if(!current)return null;
      const finish=variants.filter(v=>v.option1===current.option1&&(v.available||v.id===current.id)&&(shippable(v)||v.id===current.id));
      const sizes=[...new Set(finish.map(v=>v.option2))];
      const frames=noFrame(current.option3)?[]:[...new Set(finish.filter(v=>v.option2===current.option2).map(v=>v.option3))];
      if(sizes.length<2&&frames.length<2)return null;
      return {current,finish,sizes,frames};
    }
    function basketChoiceControls(s,{current,finish,sizes,frames}){
      const wrap=document.createElement('div');wrap.className='gwb-personalised-choices';
      const pick=(size,frame)=>finish.find(v=>v.option2===size&&v.option3===frame)||finish.find(v=>v.option2===size&&v.option3==='Black')||finish.find(v=>v.option2===size);
      const field=(label,values,value,format,onPick)=>{
        const l=document.createElement('label');l.textContent=label;
        const sel=document.createElement('select');sel.setAttribute('aria-label',label);sel.disabled=busy;
        values.forEach(v=>{const o=document.createElement('option');o.value=v;o.textContent=format(v);o.selected=v===value;sel.append(o);});
        sel.addEventListener('change',()=>onPick(sel.value));l.append(sel);wrap.append(l);
      };
      // A size the current frame colour isn't made in says so, rather than the
      // colour quietly changing when it is picked.
      const inFrame=size=>noFrame(current.option3)||finish.some(v=>v.option2===size&&v.option3===current.option3);
      field('Size',sizes,current.option2,v=>sizeLabel(sizeToken(v))+(inFrame(v)?'':` (not in ${current.option3})`),size=>{const next=pick(size,current.option3);if(next&&next.id!==current.id)swapBasketPrint(s,current,next);});
      if(frames.length)field('Frame',frames,current.option3,v=>v,frame=>{const next=pick(current.option2,frame);if(next&&next.id!==current.id)swapBasketPrint(s,current,next);});
      return wrap;
    }
    async function cartNow(){return fetch(config.root+'cart.js',{credentials:'same-origin'}).then(r=>{if(!r.ok)throw new Error();return r.json();});}
    async function cartPost(path,body){const r=await fetch(config.root+path,{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify(body)});if(!r.ok)throw new Error();return r.json();}
    async function swapBasketPrint(s,current,next){
      if(busy)return;busy=true;render();
      const statusEl=$('[data-status]');statusEl.textContent='Updating your basket…';
      // cart-attrs-sync would otherwise tidy the basket between these steps:
      // mid-swap the gift wrap briefly has two lines (old and new size), and it
      // trimmed the wrong one.
      window.__skylitCartEditInFlight=true;
      try{
        const cart=await cartNow();
        const ref=s.properties?._cart_line_ref;
        const line=cart.items.find(i=>i.key===s.cartKey)||(ref&&cart.items.find(i=>i.properties?._cart_line_ref===ref&&String(i.variant_id)===String(current.id)));
        if(!line)throw new Error();
        const token=sizeToken(next.option2);
        const props={...(line.properties||{})};
        if('_selected_size' in props)props._selected_size=token;
        if('_size' in props)props._size=token;
        if('_selected_frame' in props)props._selected_frame=noFrame(next.option3)?props._selected_frame:next.option3;
        if('_frame' in props&&!noFrame(next.option3))props._frame=next.option3;
        if('_aspect_ratio' in props){const m=token.match(/(\d+)x(\d+)/),[a,b]=m?[+m[1],+m[2]]:[21,29.7];props._aspect_ratio=((Number(props._aspect_ratio)<100?Math.min(a,b)/Math.max(a,b):Math.max(a,b)/Math.min(a,b))*100).toFixed(2);}
        // 1. The same design as the new variant, then 2. without the old line.
        await cartPost('cart/add.js',{items:[{id:next.id,quantity:line.quantity,properties:props}]});
        const after=await cartNow();
        const old=after.items.find(i=>String(i.variant_id)===String(current.id)&&(ref?i.properties?._cart_line_ref===ref:i.key===line.key));
        if(old)await cartPost('cart/change.js',{id:old.key,quantity:0});
        // 3. Gift wrap / bundle priced by size follow the print to its new tier.
        if(sizeToken(current.option2)!==token&&window.SkylitGifts){
          const GIFT={'gift-wrap':'giftwrap','gift-bundle':'bundle'};
          const gifts=(await cartNow()).items.filter(i=>GIFT[i.handle]&&(ref?i.properties?._paired_with_line_ref===ref:i.properties?._paired_with_order_id===s.orderId));
          for(const g of gifts){
            const id=window.SkylitGifts.variantFor(GIFT[g.handle],token,window.SkylitGifts.designFor(g.variant_id)||g.variant_title||'');
            if(!id||String(id)===String(g.variant_id))continue;
            await cartPost('cart/add.js',{items:[{id,quantity:g.quantity,properties:g.properties||{}}]});
            const fresh=(await cartNow()).items.find(i=>String(i.variant_id)===String(g.variant_id)&&JSON.stringify(i.properties||{})===JSON.stringify(g.properties||{}));
            if(fresh)await cartPost('cart/change.js',{id:fresh.key,quantity:0});
          }
        }
        // 4. The saved design learns its new size / frame; its basket mockup re-renders.
        const route=DATA_ROUTE[s.handle];
        if(route&&s.orderId){
          const body={order:s.orderId,_partial:true,size:token,funnel_status:'cart'};
          if(!noFrame(next.option3))body.selected_frame=next.option3;
          fetch('https://admin.skylitstudio.co.uk/api/'+route+'/',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).catch(()=>{});
        }
        wallEvent('basket_print_changed',{slot:active,size:token,frame:noFrame(next.option3)?'':next.option3},s.orderId);
        window.__skylitCartEditInFlight=false;
        busy=false;await loadCart();
        const frameMoved=!noFrame(current.option3)&&next.option3!==current.option3&&sizeToken(current.option2)!==token;
        statusEl.textContent=frameMoved
          ?`Updated in your basket: ${sizeLabel(token)}. ${current.option3} frames aren't available in that size, so it's now ${next.option3}.`
          :`Updated in your basket: ${sizeLabel(token)}${noFrame(next.option3)?'':', '+next.option3+' frame'}.`;
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'gallery-wall'}}));
      }catch(e){
        window.__skylitCartEditInFlight=false;
        busy=false;render();statusEl.textContent='That change could not be saved. Please try again.';
      }
      if(window.__cartAttrsSync)setTimeout(window.__cartAttrsSync,400);
    }
    function renderPersonalisedActions(options,s){
      const details=document.createElement('dl');details.className='gwb-personalised-details';
      const rawSize=String(s.properties?._selected_size||s.size||'').trim();
      const sizeMatch=rawSize.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:cm)?$/i);
      const size=sizeMatch?`${sizeMatch[1]} × ${sizeMatch[2]} cm`:rawSize;
      const finish=s.cartFrame?'Framed':String(s.type||'').trim(),frame=String(s.cartFrame?.variant_options?.[0]||s.frame||'').trim();
      // A basket print (its own finish, no separate frame add-on) can change size
      // and frame colour right here; those rows then become dropdowns.
      const choices=!isPlanned(s)&&s.cartKey&&!s.cartFrame?basketChoices(s):null;
      const rows=[['Size',choices?'':size],['Finish',finish],['Frame',choices||/unframed|digital/i.test(finish)?'':frame]];
      rows.forEach(([label,value])=>{if(!value)return;const row=document.createElement('div');
        const term=document.createElement('dt'),description=document.createElement('dd');
        term.textContent=label;description.textContent=value;row.append(term,description);details.append(row);
      });
      if(details.childElementCount)options.append(details);
      if(choices)options.append(basketChoiceControls(s,choices));
      if(isPlanned(s)){
        // The draft is a real saved design, so the customiser opens it like any
        // saved order; adding it there returns it to this slot as a basket item.
        const actions=document.createElement('div');actions.className='gwb-personalised-actions';
        const edit=document.createElement('a');edit.className='gwb-edit-design';edit.textContent='Fine-tune in the editor';
        const editUrl=new URL(s.productUrl||('/products/'+s.handle),window.location.origin);editUrl.searchParams.set('order_id',s.orderId);editUrl.searchParams.set('gallery_wall',wallId);editUrl.searchParams.set('gallery_slot',String(active));edit.href=editUrl.pathname+editUrl.search;
        edit.addEventListener('click',()=>{saveWall();wallEvent('fine_tune_opened',{slot:active},s.orderId,s.planId);});
        const remove=document.createElement('button');remove.type='button';remove.textContent='Remove from wall';remove.addEventListener('click',()=>{selected[active]=null;render();});
        actions.append(edit,remove);options.append(actions);
        const note=document.createElement('p');note.className='gwb-companion-note';note.textContent=`${s.summary?s.summary+'. ':''}Adds to your basket with the rest of the wall. Fine-tune it in the editor first if you like.`;options.append(note);
        return;
      }
      const control=frameControls&&[...frameControls.querySelectorAll('[data-gallery-frame-key]')].find(el=>el.dataset.galleryFrameKey===s.cartKey);
      if(control?.querySelector('[data-frame-upsell]')){
        const wrap=document.createElement('div');wrap.className='gwb-frame-controls';const hint=document.createElement('p');hint.className='gwb-frame-basket-note';hint.textContent='Frame changes update your basket immediately.';wrap.append(hint,control.cloneNode(true));options.append(wrap);
        queueMicrotask(()=>document.dispatchEvent(new CustomEvent('gallery:frame-controls-ready')));
      }
      const actions=document.createElement('div');actions.className='gwb-personalised-actions';
      const edit=document.createElement('a');edit.className='gwb-edit-design';edit.textContent='Edit design';
      const editUrl=new URL(s.productUrl||('/products/'+s.handle),window.location.origin);editUrl.searchParams.set('order_id',s.orderId);editUrl.searchParams.set('gallery_wall',wallId);editUrl.searchParams.set('gallery_slot',String(active));edit.href=editUrl.pathname+editUrl.search;edit.addEventListener('click',()=>wallEvent('edit_design_opened',{slot:active},s.orderId));actions.append(edit);
      const empty=selected.findIndex((v,i)=>!v&&i!==active);
      if(empty>=0){const repeat=document.createElement('button');repeat.type='button';repeat.textContent=s.cartFrame?'Repeat print without frame':'Repeat exact print';repeat.addEventListener('click',async()=>{
        repeat.disabled=true;const props={...(s.properties||{}),_cart_line_ref:'gwb_'+Math.random().toString(36).slice(2,12),_gallery_wall_id:wallId,_gallery_wall_slot:String(empty)};
        try{const res=await fetch(config.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:s.variantId,quantity:1,properties:props}]})});if(!res.ok)throw new Error();const body=await res.json();const added=(body.items||[body])[0];selected[empty]=personalisedFromItem(added);cartItems.push(added);active=empty;render();renderCartImport();}
        catch(e){$('[data-status]').textContent='That print could not be repeated. Please try again.';repeat.disabled=false;}
      });actions.append(repeat);}
      const remove=document.createElement('button');remove.type='button';remove.textContent='Remove from wall';remove.addEventListener('click',()=>{selected[active]=null;render();renderCartImport();});actions.append(remove);
      options.append(actions);const note=document.createElement('p');note.className='gwb-companion-note';note.textContent='Already in your basket. Removing it here will not remove it from the basket.';options.append(note);
    }

    const preview=$('.gwb-preview'), fullscreenButton=$('[data-fullscreen]');
    const fullscreen=document.createElement('dialog');
    fullscreen.className='gwb-fullscreen';fullscreen.setAttribute('aria-label','Fullscreen gallery wall preview');
    root.append(fullscreen);
    const previewHome=document.createComment('Gallery preview position');
    let previousOverflow='';
    fullscreenButton.addEventListener('click',()=>{
      if(fullscreen.open){fullscreen.close();return;}
      preview.before(previewHome);fullscreen.append(preview);
      previousOverflow=document.documentElement.style.overflow;
      document.documentElement.style.overflow='hidden';
      $('.gwb-pair').inert=true;
      fullscreenButton.textContent='Exit fullscreen';
      fullscreenButton.removeAttribute('aria-haspopup');
      setMovePrints(false);fullscreen.showModal();fit();fullscreenButton.focus({preventScroll:true});
      // The page cannot scroll behind the modal, so the lock has nothing to
      // protect: open fullscreen ready to drag around a zoomed-in wall. Closing
      // relocks (see the close handler) so the editor keeps scrolling normally.
      setExplore(true);
    });
    fullscreen.addEventListener('close',()=>{
      setExplore(false);
      previewHome.replaceWith(preview);
      document.documentElement.style.overflow=previousOverflow;
      $('.gwb-pair').inert=false;
      fullscreenButton.textContent='Fullscreen';
      fullscreenButton.setAttribute('aria-haspopup','dialog');
      fit();fullscreenButton.focus({preventScroll:true});
    });

    $('[data-search]').addEventListener('input',renderProducts);
    function roomDb(){return new Promise((resolve,reject)=>{const request=indexedDB.open('skylit-gallery-wall',1);request.onupgradeneeded=()=>request.result.createObjectStore('rooms',{keyPath:'id'});request.onsuccess=()=>resolve(request.result);request.onerror=()=>reject(request.error);});}
    async function writeRoom(){
      if(!customPhoto)return;
      try{if(!customPhoto.buffer)customPhoto.buffer=await customPhoto.blob.arrayBuffer();const db=await roomDb(),tx=db.transaction('rooms','readwrite');tx.objectStore('rooms').put({id:wallId,buffer:customPhoto.buffer,type:customPhoto.blob.type,aspect:customPhoto.aspect,defaultWidth:customPhoto.defaultWidth,baseWidth:customPhoto.baseWidth,zoom:customPhoto.zoom,x:customPhoto.x,y:customPhoto.y,active:customPhotoActive,updated:Date.now()});await new Promise((resolve,reject)=>{tx.oncomplete=resolve;tx.onerror=()=>reject(tx.error);tx.onabort=()=>reject(tx.error);});db.close();}catch(e){}
    }
    async function deleteRoom(){try{const db=await roomDb(),tx=db.transaction('rooms','readwrite');tx.objectStore('rooms').delete(wallId);tx.oncomplete=()=>db.close();}catch(e){}}
    async function restoreRoom(){
      try{const db=await roomDb(),tx=db.transaction('rooms','readonly'),request=tx.objectStore('rooms').get(wallId);request.onsuccess=()=>{const r=request.result;db.close();if(!r||!r.buffer||Date.now()-r.updated>86400000)return;const blob=new Blob([r.buffer],{type:r.type||'image/jpeg'}),url=URL.createObjectURL(blob);customPhoto={url,blob,buffer:r.buffer,aspect:r.aspect,defaultWidth:r.defaultWidth,baseWidth:r.baseWidth,zoom:r.zoom,x:r.x,y:r.y};if(r.active){$('[data-photo-x]').value=r.x;$('[data-photo-y]').value=r.y;$('[data-photo-zoom]').value=Math.round(r.zoom*100);activatePhoto();photoStatus.textContent='Your room photo was restored on this device.';}};}catch(e){}
    }
    let roomSaveTimer=0;function scheduleRoomSave(){clearTimeout(roomSaveTimer);roomSaveTimer=setTimeout(writeRoom,180);}
    let roomRequest=0;
    root.querySelectorAll('[data-room]').forEach(b=>b.addEventListener('click',async()=>{
      const request=++roomRequest, image=new Image();image.src=b.dataset.room;
      $('[data-status]').textContent='Loading room…';
      try{await image.decode();if(request!==roomRequest)return;
        customPhotoActive=false;
        $('[data-upload-tools]').hidden=true;$('[data-upload-room]').setAttribute('aria-pressed','false');
        $('[data-upload-status]').textContent='';
        const room=$('.gwb-room-image');room.src=image.src;room.hidden=false;refitKeepingView();
        $('.gwb-preview').classList.add('gwb-preview--room');
        root.querySelectorAll('[data-room]').forEach(c=>c.setAttribute('aria-pressed',String(c===b)));
        $('[data-status]').textContent='';
        scheduleRoomSave();
      }catch{if(request===roomRequest)$('[data-status]').textContent='This room could not load. Please try again.';}
    }));
    const photoFile=$('[data-photo-file]'), photoStatus=$('[data-upload-status]');
    function positionPhoto(){
      if(!customPhotoActive || !customPhoto)return;
      const p=customPhoto,w=p.baseWidth*p.zoom,h=w/p.aspect,room=$('.gwb-room-image');
      room.style.width=w+'px';room.style.height=h+'px';
      room.style.left=(500-w/2+p.x)+'px';room.style.top=(270-h/2+p.y)+'px';
    }
    function activatePhoto(){
      if(!customPhoto)return;
      roomRequest++;customPhotoActive=true;
      $('.gwb-room-image').src=customPhoto.url;$('.gwb-room-image').hidden=false;
      $('[data-upload-tools]').hidden=false;
      $('[data-upload-room]').textContent='Your room';$('[data-upload-room]').setAttribute('aria-pressed','true');
      root.querySelectorAll('[data-room]').forEach(b=>b.setAttribute('aria-pressed','false'));
      $('[data-status]').textContent='';fit();
    }
    function resetPhotoPosition(){
      if(!customPhoto)return;
      customPhoto.x=customPhoto.y=0;customPhoto.zoom=1;
      $('[data-photo-x]').value=$('[data-photo-y]').value='0';$('[data-photo-zoom]').value='100';positionPhoto();
    }
    $('[data-upload-room]').addEventListener('click',()=>customPhoto?activatePhoto():photoFile.click());
    $('[data-photo-replace]').addEventListener('click',()=>photoFile.click());
    photoFile.addEventListener('change',async()=>{
      const file=photoFile.files[0];photoFile.value='';if(!file)return;
      if(file.size>20*1024*1024){photoStatus.textContent='Please choose a photo smaller than 20 MB.';return;}
      if(!file.type.startsWith('image/')){photoStatus.textContent='Please choose a photo, such as a JPEG, PNG or WebP image.';return;}
      const request=++roomRequest,url=URL.createObjectURL(file),image=new Image();
      photoStatus.textContent='Opening your photo…';image.src=url;
      try{
        await image.decode();
        if(request!==roomRequest){URL.revokeObjectURL(url);return;}
        if(image.naturalWidth*image.naturalHeight>40000000)throw new Error('large');
        const aspect=image.naturalWidth/image.naturalHeight;
        const defaultWidth=Math.max(viewport.clientWidth/fitScale,viewport.clientHeight/fitScale*aspect);
        if(customPhoto)URL.revokeObjectURL(customPhoto.url);
        customPhoto={url,blob:file,aspect,defaultWidth,baseWidth:defaultWidth,zoom:1,x:0,y:0};
        $('[data-photo-width]').value='';$('[data-photo-zoom]').disabled=false;
        activatePhoto();resetPhotoPosition();
        photoStatus.textContent='Photo ready. It stays on this device and is kept while you customise prints.';writeRoom();
      }catch(error){URL.revokeObjectURL(url);if(request===roomRequest)photoStatus.textContent=error.message==='large'?'Please resize this photo to under 40 megapixels and try again.':'This photo could not be opened. Try a JPEG, PNG or WebP version.';}
    });
    [['zoom',100],['x',1],['y',1]].forEach(([key,divisor])=>{
      $('[data-photo-'+key+']').addEventListener('input',e=>{if(customPhoto){customPhoto[key]=Number(e.target.value)/divisor;positionPhoto();scheduleRoomSave();}});
    });
    $('[data-photo-calibrate]').addEventListener('click',()=>{
      if(!customPhoto)return;
      const width=Number($('[data-photo-width]').value);
      if(!Number.isFinite(width)||width<30||width>2000){photoStatus.textContent='Enter a wall width between 30 and 2,000 cm, or clear the width.';return;}
      // Artwork dimensions use 5.5 world pixels per cm; the full photo width shares that scale.
      customPhoto.baseWidth=width*5.5;customPhoto.zoom=1;
      $('[data-photo-zoom]').value='100';$('[data-photo-zoom]').disabled=true;positionPhoto();
      writeRoom();
      photoStatus.textContent=`Photo width set to ${width} cm. Scale is approximate; measure your wall before ordering.`;
    });
    $('[data-photo-clear-scale]').addEventListener('click',()=>{
      if(!customPhoto)return;
      customPhoto.baseWidth=customPhoto.defaultWidth;$('[data-photo-width]').value='';$('[data-photo-zoom]').disabled=false;
      resetPhotoPosition();writeRoom();photoStatus.textContent='Returned to a styling preview.';
    });
    $('[data-photo-reset]').addEventListener('click',()=>{
      resetPhotoPosition();
      writeRoom();
    });
    $('[data-photo-remove]').addEventListener('click',()=>{
      roomRequest++;customPhotoActive=false;
      if(customPhoto)URL.revokeObjectURL(customPhoto.url);customPhoto=null;
      deleteRoom();
      $('[data-upload-tools]').hidden=true;$('[data-upload-room]').textContent='＋ Upload your room';$('[data-upload-room]').setAttribute('aria-pressed','false');
      const fallback=root.querySelector('[data-room]');$('.gwb-room-image').src=fallback.dataset.room;fit();
      photoStatus.textContent='Photo removed.';fallback.click();
    });
    root.querySelectorAll('[data-zoom]').forEach(b=>b.addEventListener('click',()=>b.dataset.zoom==='fit'?fit():zoom(scale*(b.dataset.zoom==='in'?1.25:.8))));
    function setExplore(enabled){
      if(enabled&&movePrints)setMovePrints(false);
      exploreEnabled=enabled;points.forEach((_,id)=>{if(viewport.hasPointerCapture(id))viewport.releasePointerCapture(id);});points.clear();gesture=null;moved=false;
      viewport.classList.toggle('gwb-viewport--exploring',enabled);
      $('[data-explore-toggle]').setAttribute('aria-pressed',String(enabled));
      const lockLabel=enabled?'Lock view':'Unlock view to pan and zoom';
      $('[data-explore-toggle]').setAttribute('aria-label',lockLabel);
      $('[data-explore-toggle]').title=lockLabel;
      $('[data-lock-shackle]').setAttribute('d',enabled?'M8 10V6a4 4 0 0 1 8 0':'M8 10V6a4 4 0 0 1 8 0v4');
      $('[data-explore-hint]').textContent=enabled?'Drag to explore · Pinch to zoom':'View locked · Scroll normally';
    }
    $('[data-explore-toggle]').addEventListener('click',()=>setExplore(!exploreEnabled));
    function capturePositions(){if(!template.positions)template.positions=slots.map(slot=>[parseFloat(slot.style.left),parseFloat(slot.style.top)]);}
    viewport.addEventListener('pointerdown',e=>{
      if(!movePrints||e.button!==0||printDrag)return;
      const slot=e.target.closest('[data-slot]');if(!slot)return;
      active=Number(slot.dataset.slot);capturePositions();
      printDrag={id:e.pointerId,index:active,x:e.clientX,y:e.clientY,start:template.positions[active].slice()};
      moved=false;slot.setPointerCapture(e.pointerId);slot.focus({preventScroll:true});render();
    });
    viewport.addEventListener('pointermove',e=>{
      if(!printDrag||printDrag.id!==e.pointerId)return;
      const dx=(e.clientX-printDrag.x)/scale,dy=(e.clientY-printDrag.y)/scale;
      if(Math.hypot(e.clientX-printDrag.x,e.clientY-printDrag.y)<5&&!moved)return;
      moved=true;
      let left=printDrag.start[0]+dx,top=printDrag.start[1]+dy;
      // Snap matching edges and centres within eight screen pixels.
      const [w,h]=dimensions(selected[active],active),tolerance=8/scale;
      let snapX=tolerance,snapY=tolerance,adjustX=0,adjustY=0;
      template.positions.forEach((p,i)=>{if(i===active)return;const [ow,oh]=dimensions(selected[i],i);
        for(const delta of [p[0]-left,p[0]+ow-left-w,p[0]+ow/2-left-w/2])if(Math.abs(delta)<snapX){snapX=Math.abs(delta);adjustX=delta;}
        for(const delta of [p[1]-top,p[1]+oh-top-h,p[1]+oh/2-top-h/2])if(Math.abs(delta)<snapY){snapY=Math.abs(delta);adjustY=delta;}
      });
      template.positions[active]=movePrint([clamp(left+adjustX,-10000,10000),clamp(top+adjustY,-10000,10000)],active);layoutWall();
    });
    function finishPrintDrag(e){if(printDrag?.id!==e.pointerId)return;printDrag=null;render();}
    window.addEventListener('pointerup',finishPrintDrag);window.addEventListener('pointercancel',finishPrintDrag);
    viewport.addEventListener('keydown',e=>{
      if(!movePrints||!e.target.matches('[data-slot]'))return;
      const direction={ArrowLeft:[-1,0],ArrowRight:[1,0],ArrowUp:[0,-1],ArrowDown:[0,1]}[e.key];if(!direction)return;
      e.preventDefault();capturePositions();active=Number(e.target.dataset.slot);
      const step=e.shiftKey?27.5:5.5;
      template.positions[active]=movePrint(template.positions[active].map((v,i)=>clamp(v+direction[i]*step,-10000,10000)),active);render();
    });
    function baseline(){const ps=[...points.values()];gesture={ps,x,y,scale};}
    viewport.addEventListener('pointerdown',e=>{if(!exploreEnabled||e.button!==0)return;points.set(e.pointerId,{x:e.clientX,y:e.clientY});if(points.size===1)moved=false;baseline();});
    viewport.addEventListener('pointermove',e=>{
      if(!exploreEnabled||!points.has(e.pointerId))return;
      points.set(e.pointerId,{x:e.clientX,y:e.clientY}); const ps=[...points.values()];
      const dx=ps[0].x-gesture.ps[0].x,dy=ps[0].y-gesture.ps[0].y;
      if(Math.hypot(dx,dy)>5 || ps.length>1){moved=true;viewport.setPointerCapture(e.pointerId);}
      if(!moved)return;
      if(ps.length===2 && gesture.ps.length===2){
        const dist=a=>Math.hypot(a[0].x-a[1].x,a[0].y-a[1].y);
        const rect=viewport.getBoundingClientRect();
        const old={x:(gesture.ps[0].x+gesture.ps[1].x)/2-rect.left,y:(gesture.ps[0].y+gesture.ps[1].y)/2-rect.top};
        scale=clamp(gesture.scale*dist(ps)/Math.max(1,dist(gesture.ps)),fitScale*.7,fitScale*3);
        x=(ps[0].x+ps[1].x)/2-rect.left-(old.x-gesture.x)*scale/gesture.scale;
        y=(ps[0].y+ps[1].y)/2-rect.top-(old.y-gesture.y)*scale/gesture.scale;
      }else{x=gesture.x+dx;y=gesture.y+dy;}transform();
    });
    const end=e=>{points.delete(e.pointerId);baseline();};
    window.addEventListener('pointerup',end);window.addEventListener('pointercancel',end);
    viewport.addEventListener('keydown',e=>{if(!exploreEnabled||e.target!==viewport)return;const delta={ArrowLeft:[30,0],ArrowRight:[-30,0],ArrowUp:[0,30],ArrowDown:[0,-30]}[e.key];if(delta){e.preventDefault();x+=delta[0];y+=delta[1];transform();}});
    // Same add-to-basket motion as the customisers (skylit-motion.js,
    // skylit-star-trail.js): the button closes to a spinner, a comet flies to
    // the basket, then a tick opens out to "Added" before the cart loads.
    // Without either script the plain text path runs as before.
    let cartFlight=null;
    function stopAtc(instant){if(cartFlight)cartFlight.cancel();cartFlight=null;atcMorph.reset(instant);}
    window.addEventListener('pageshow',e=>{if(e.persisted){stopAtc(true);busy=false;render();}});
    $('.gwb-add').addEventListener('click',async()=>{
      if(busy||!selected.every(Boolean))return;
      const addButton=$('.gwb-add'),adding=selected.some(s=>!isPersonalised(s)||isPlanned(s));
      if(adding){
        atcMorph.start(addButton,'Adding your gallery wall…');
        cartFlight=window.SkylitStarTrail?window.SkylitStarTrail.launch(addButton,[document.getElementById('cart-icon-bubble')]):null;
      }
      busy=true;render();$('[data-status]').textContent='Adding your gallery wall…';
      wallEvent('wall_add_to_basket',{slots:selected.length,planned:selected.filter(isPlanned).length,personalised:selected.filter(s=>isPersonalised(s)&&!isPlanned(s)).length,space:selected.filter(s=>s&&!isPersonalised(s)).length});
      try{
        const pending=selected.filter(s=>!isPersonalised(s)).map(s=>({id:s.variant.id,quantity:1}));
        // Planned designs: the server moves each draft to the basket stage and returns
        // the exact line to add. A design it cannot confirm is never added.
        const planned=selected.map((s,i)=>isPlanned(s)?{s,i}:null).filter(Boolean);
        const byPlan=new Map();planned.forEach(({s,i})=>{if(!byPlan.has(s.planId))byPlan.set(s.planId,[]);byPlan.get(s.planId).push(s.planIndex);});
        let skipped=0;
        for(const [planId,indexes] of byPlan){
          const res=await fetch(config.planner+'commit',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({plan_id:planId,wall_id:wallId,indexes})});
          const body=await res.json().catch(()=>({}));
          if(!res.ok)throw new Error('Your planned prints could not be added. Please try again.');
          (body.lines||[]).forEach(line=>pending.push({id:Number(line.variant_id),quantity:1,properties:{...line.properties,_gallery_wall_id:wallId,_gallery_wall_slot:String(planned.find(p=>p.s.planId===planId&&p.s.planIndex===line.index)?.i??line.index)}}));
          skipped+=(body.missing||[]).length;
        }
        if(skipped)$('[data-status]').textContent=`${skipped} planned ${skipped===1?'print':'prints'} could not be added. Open ${skipped===1?'it':'them'} in the editor to finish.`;
        if(pending.length){const response=await fetch(config.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:pending})});
        const body=await response.json();if(!response.ok)throw new Error(body.description || 'Your gallery wall could not be added. Please try again.');}
        if(skipped){stopAtc();busy=false;loadCart();return;}
        if(atcMorph.active()){
          atcMorph.success('Added');$('[data-status]').textContent='Added to your basket.';
          await Promise.all([cartFlight?cartFlight.land():null,atcMorph.settle()]).catch(()=>{});
        }
        window.location.assign(config.root+'cart');
      }catch(error){stopAtc();$('[data-status]').textContent=error.message;busy=false;render();}
    });
    const stickyHeader=document.querySelector('sticky-header');
    if(stickyHeader){const updateStickyTop=()=>root.style.setProperty('--gwb-sticky-top',`${stickyHeader.getBoundingClientRect().height+16}px`);updateStickyTop();new ResizeObserver(updateStickyTop).observe(stickyHeader);}
    document.addEventListener('cart:updated',()=>loadCart());
    $('.gwb-room-image').addEventListener('load',()=>{if(!customPhotoActive)refitKeepingView();});
    new ResizeObserver(scrollActiveTab).observe($('.gwb-tabs'));
    // "Describe your wall" (gallery-wall-describe.js) plans prints on the server
    // and hands the result back here. Planned designs are saved drafts with a
    // cart thumbnail rendering; space prints map onto the catalogue.
    function spaceVariant(product,index,frame,finish){
      const fits=product.variants.filter(v=>eligible(v)&&normalSize(v.option2)===normalSize(template.sizes[index]));
      const want=finish==='print'?/unframed/i:frame==='White'?/white/i:frame==='Natural'?/natural|oak/i:frame==='Dark Brown'?/dark brown|walnut/i:/black/i;
      return fits.find(v=>want.test(v.option1||v.title))||chooseVariant(product,index,null);
    }
    function plannedFromSlot(slot,planId){
      const meta=personalisedProducts.find(p=>p.handle===slot.handle);
      const d=slot.design||{};
      return {kind:'personalised',planned:true,planId,planIndex:slot.index,handle:slot.handle,title:personalisedLabel(slot.handle)||meta?.title||'Personalised print',
        productUrl:meta?.url||('/products/'+slot.handle),variantId:Number(slot.variant_id),cartFrame:null,cartKey:'',lineRef:'',orderId:slot.order_id,
        image:slot.thumbnail_print||slot.thumbnail_final||meta?.image||'',renderBacked:Boolean(slot.thumbnail_print||slot.thumbnail_final),imagePending:Boolean(slot.thumbnail_print||slot.thumbnail_final),
        size:slot.size,type:slot.finish==='framed'?'Framed':slot.finish==='canvas'?'Canvas':'Print',frame:slot.finish==='framed'?slot.frame:'',
        orientation:d.orientation==='landscape'?'landscape':'portrait',price:Number(slot.price||0),summary:slot.summary||'',reason:slot.reason||'',properties:slot.properties||{}};
    }
    root.gwbPlanner={
      wallId,
      event:wallEvent,
      state(){
        return {layout:template.id,sizes:template.sizes.slice(),filled:selected.map(s=>s?(isPlanned(s)?'planned':isPersonalised(s)?'personalised':'space'):null)};
      },
      moment:()=>sourceMoment(),
      spacePrints:()=>products.map(p=>({handle:p.handle,title:shortTitle(p)})).filter(p=>p.handle).slice(0,80),
      applyPlan(plan){
        const slots=(plan.slots||[]).slice(0,maxPrints);if(!slots.length)return;
        setMovePrints(false);
        const sizes=slots.map(s=>/^(A4|30x40|40x50|50x70|60x80)$/.test(s.size)?s.size:'30x40');
        const n=sizes.length;
        template={id:'custom',name:'Your described wall',sizes,layout:n<=3?'row':n===5?'staggered':'grid',columns:n===4?2:3,gap:32};
        selected.length=n;selected.fill(null);
        slots.forEach((slot,i)=>{
          if(slot.status==='ready')selected[i]=plannedFromSlot(slot,plan.plan_id);
          else if(slot.status==='space'){
            const product=products.find(p=>p.handle===slot.space_handle);
            const variant=product&&spaceVariant(product,i,slot.frame,slot.finish);
            if(variant)selected[i]={product,variant};
          }
        });
        active=Math.max(0,selected.findIndex(s=>!s));if(!selected[active]&&selected.every(Boolean))active=0;
        buildSlots();render();fit();
      }
    };
    restoreWall();buildSlots();restoring=false;new ResizeObserver(refitKeepingView).observe(viewport);render();fit();loadCart();restoreRoom();
  }
  document.querySelectorAll('[data-gallery-wall]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-gallery-wall]').forEach(init));
})();
